import React, { useState } from 'react';
import { ErrorMessage } from 'formik';
import PropTypes from 'prop-types';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

//components
import FormLabel from '../Label';
import ErrorField from '../ErrorField';
//styles
import { Suffix, Input } from './index.styled';
import { FormGroup } from 'components/styled/Form.styled';

const NumberFieldWithMask = ({
  name,
  label,
  error,
  isRequired,
  disabled,
  suffix,
  setFieldValue,
  value,
  table,
}) => {
  const [maskValue, setMaskValueState] = useState(value);

  const defaultMaskOptions = createNumberMask({
    prefix: '',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: '',
    allowDecimal: true,
    decimalLimit: 2, // how many digits allowed after the decimal
    allowNegative: false,
    allowLeadingZeroes: false,
  });

  return (
    <FormGroup>
      {label && <FormLabel isRequired={isRequired} label={label} name={name} error={error} />}
      <Input
        value={maskValue}
        disabled={disabled}
        name={name}
        error={error ? 'hasError' : 'noError'}
        placeholder="__,__"
        mask={defaultMaskOptions}
        id={name}
        onChange={e => {
          setMaskValueState(e.target.value);
          setFieldValue(name, e.target.value);
        }}
        type="number"
      />
      {!table && <ErrorMessage name={name} component={ErrorField} />}
      <Suffix error={error} table={table}>
        {suffix}
      </Suffix>
    </FormGroup>
  );
};

NumberFieldWithMask.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  error: PropTypes.bool,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  table: PropTypes.bool,
  suffix: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  value: PropTypes.number,
};

export default NumberFieldWithMask;
